import React, { useEffect, useState, useMemo, useRef } from 'react'
import Select from 'react-select';
import axios from "axios";
import { Range, getTrackBackground } from "react-range";
import { FaFilter } from 'react-icons/fa'
import LoadingSpinner from '../Helper/LoadingSpinner';
import useToken from '../App/useToken';
import DropdownMenu from '../Helper/DropdownMenu';

const StemCurveCard = ({ items, selectedFlight, height="100%", centerOnAnnotation=null, annotationSelected=null, isPotree=false }) => {
  const {token} = useToken()
  const [selectedId, setSelectedId] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  // const [svgContent, setSvgContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [noSvg, setNoSvg] = useState(false);
  const [options, setOptions] = useState([]);
  const [showFilters, setShowFilters] = useState(false)
  const [plotsMissing, setPlotsMissing] = useState(false);
  const [startGeneration, setStartGeneration] = useState(false);
  const [hasPlots, setHasPlots] = useState('');
  const [collapsed, setCollapsed] = useState(true);
  const [filters, setFilters] = useState({
    DBH: [0.01, 1.0],
    volume: [0.0, 5.0],
    height: [0, 40]
  });

  const [minMax, setMinMax] = useState({
    DBH: [0.01, 1.0],
    volume: [0.0, 5.0],
    height: [0, 40]
  });

  const containerRef = useRef();
  // useEffect(()=>{
  //   fetchSvgForId()
  // }, [clickedAnnotation])
  useEffect(()=>{
    // console.log('reseting')
    setHasPlots('')
    setPlotsMissing(false)
    setStartGeneration(false)
    setImageUrl(null)
    setNoSvg(false)
  }, [selectedFlight])
  useEffect(() => {
    if (options.length === 0) return;
    const getRange = (key) => {
      const values = options.map(opt => opt.data[key]);
      return [Math.min(...values), Math.max(...values)];
    };
    setMinMax({
      DBH: getRange("DBH"),
      volume: getRange("volume"),
      height: getRange("height")
    });
    setFilters({
      DBH: getRange("DBH"),
      volume: getRange("volume"),
      height: getRange("height")
    });
  }, [options]);

  const updateFilter = (field, values) => {
    setFilters(prev => ({ ...prev, [field]: values }));
  };

  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const currentIndex = useMemo(() =>
    options.findIndex(opt => opt.data.ID === selectedId?.ID), [selectedId, options]);

  const checkHasPlots = async () => {
    setLoading(true)
    const data = {
        'token': token,
        'filename': selectedFlight.name,
        'customerId': selectedFlight.customerId,
      }
      // console.log(data)
      var config = {
        method: 'post',
        url: "api/get_flight_metadata",
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      try {
        const response = await axios(config);
        // console.log(response.data)
        if(response.status !== 200){
          setHasPlots('no')
          setStartGeneration(true)
          setPlotsMissing(true)
          setImageUrl(null);
        } else {
          if(response.data['stem_curve_plots']){
            setHasPlots(response.data['stem_curve_plots'])
            if(response.data['stem_curve_plots'] === 'no' || response.data['stem_curve_plots'] === 'failedGenerating'){
              setStartGeneration(true)
              setPlotsMissing(true)
              setImageUrl(null);
            } else {

            }
          } else {
            setHasPlots('')
            setStartGeneration(true)
            setImageUrl(null);
          }
        }
        // console.log(response)

      }
      catch (error) {
        // console.log(error)
        setHasPlots('no')
        setStartGeneration(true)
        setPlotsMissing(true)
        setImageUrl(null);
      } 
      finally {
        setLoading(false)
      }
  }
  const fetchSvgForId = async (id) => {
    setNoSvg(false);
    setLoading(true);
    if(id){
      const data = {
        'token': token,
        'id': id,
        'filename': selectedFlight.name,
        'customerId': selectedFlight.customerId,
        'DOF': selectedFlight.DOF,
        'droneId': selectedFlight.droneId
      }
      // console.log(data)
      var config = {
        method: 'post',
        url: "file-handler/get_stem_curve_plot",
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: "blob",
        data: data
      };
      try {
        const response = await axios(config);
        // console.log(response)
         if (response.status === 202) {
          // console.log(plotsMissing)
          if(hasPlots === 'yes'){
            setPlotsMissing(false)
          }
          setImageUrl(null);
          setNoSvg(true);
          return null;
        }

        if (response.status === 204) {
          setNoSvg(true);
          setImageUrl(null);
          
          return;
        }
        // if (response.data.svg) {
        //   setSvgContent(response.data.svg);
        //   setNoSvg(false);
        // } else {
        //   setNoSvg(true);
        // }
        // Convert blob to object URL
        if(response.data){
          const url = URL.createObjectURL(response.data);
          setImageUrl(url);
          setNoSvg(false);
          setPlotsMissing(false);
          
        } 
        else {
          setNoSvg(true);
          setImageUrl(null);
          

        }
      } catch (error) {
        console.error("PNG fetch error:", error);
        // setSvgContent(null)
        setImageUrl(null);
        setNoSvg(true);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleGeneratePlots = async () => {
    const data = {
        'token': token,
        'filename': selectedFlight.name,
        'customerId': selectedFlight.customerId,
        'DOF': selectedFlight.DOF,
        'droneId': selectedFlight.droneId
      }
      var config = {
        method: 'post',
        url: "file-handler/generate_stem_curve_plots",
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      try {
        const response = await axios(config);
        if(response.status === 200){
          setStartGeneration(false);
          setPlotsMissing(false)
        } else {
          alert("Failed to start generation. Try again later.");
          setStartGeneration(true)
          setPlotsMissing(true)

        }
      } catch (error) {
        console.error("Failed to start plot generation:", error);
        alert("Failed to start generation. Try again later.");
        setStartGeneration(true)
        setPlotsMissing(true)


      }
  };
  useEffect(() => {
    return () => {
      if (imageUrl) URL.revokeObjectURL(imageUrl);
    };
  }, [imageUrl]);
  useEffect(()=> {
    // console.log(hasPlots)
    if(hasPlots === 'yes' && selectedId && selectedId.ID != null && selectedFlight.name !== ''){
      fetchSvgForId(selectedId.ID)
      isPotree && centerOnAnnotation(selectedId.ID)
    }
  }, [selectedId, hasPlots])
  useEffect(()=>{
    if(annotationSelected && options){
      // console.log(options)
      let op = options.find(op => op.data.ID === annotationSelected)
      // console.log(op)
      if(op && selectedId.ID !== op.data.ID){

        setSelectedId(op.data)
      } 
    }
  }, [annotationSelected, options])
  useEffect(() => {
    setHasPlots('')
    const mappedOptions = items
    .slice(1)
    .filter(opt => opt.ID && opt.DBH && opt.volume && opt.height)
    .map(opt => ({
      value: opt.ID,
      label: `Tree ID: ${opt.ID} {DBH: ${opt.DBH}, Volume: ${opt.volume}, Height: ${opt.height}}`,
      data: opt // THIS MUST BE PRESENT
    }));
    
    setOptions(mappedOptions);
    if (mappedOptions.length > 0) {
      checkHasPlots()
      setSelectedId(mappedOptions[0].data);
    }
  }, [items]);

  const goTo = (offset) => {
    if (!filteredAndSortedOptions.length) return;
    let nextIndex = (currentIndex + offset + filteredAndSortedOptions.length) % filteredAndSortedOptions.length;
    setSelectedId(filteredAndSortedOptions[nextIndex].data);
  };

  const toggleSort = (field) => {
    const fieldMap = {
      DBH: 'DBH',
      volume: 'volume',
      height: 'height'
    };
    const normalizedField = fieldMap[field] || field;

    if (sortBy === normalizedField) {
      setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortBy(normalizedField);
      setSortDirection('asc');
    }
  };

  const filteredAndSortedOptions = useMemo(() => {
    const filtered = [...options].filter(opt => {
      const { DBH, volume, height } = opt.data;
      return (
        parseFloat(DBH) >= filters.DBH[0] && parseFloat(DBH) <= filters.DBH[1] &&
        parseFloat(volume) >= filters.volume[0] && parseFloat(volume) <= filters.volume[1] &&
        parseFloat(height) >= filters.height[0] && parseFloat(height) <= filters.height[1]
      );
    });

    if (sortBy) {
      filtered.sort((a, b) => {
        if (sortBy === 'ID') {
          // Try numeric comparison if IDs are numbers
          const aId = isNaN(a.data.ID) ? a.data.ID : parseInt(a.data.ID);
          const bId = isNaN(b.data.ID) ? b.data.ID : parseInt(b.data.ID);
          return sortDirection === 'asc'
            ? aId > bId ? 1 : aId < bId ? -1 : 0
            : aId < bId ? 1 : aId > bId ? -1 : 0;
        }

        const aVal = parseFloat(a.data[sortBy]);
        const bVal = parseFloat(b.data[sortBy]);
        return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      });
    }

    return filtered;
  }, [options, filters, sortBy, sortDirection]);

//   const filterOptions = (
//   candidate: { label: string; value: string; data: any },
//   input: string
// ) => {
//   if (input) {
//     return candidate.value === customOptions[0].value;
//   }
//   return true;
// };
  const customFilterOption = (candidate, input) => {
    
    if (!input){
      
      return true;
    } 
    
    
    const data = candidate.data.data;

    // ID search: plain number
    if (/^\d+$/.test(input)) {
      return data.ID.toString().includes(input);
    }

    // Attribute matchers
    const checkMatch = (key, inputPattern, tolerance = 0.01) => {
      const match = input.match(inputPattern);
      if (match) {
        const min = parseFloat(match[1]);
        const max = match[3] ? parseFloat(match[3]) : min;
        const value = parseFloat(data[key]);
        return value >= min - tolerance && value <= max + tolerance;
      }
      return false;
    };

    return (
      checkMatch("DBH", /\{?\s*DBH\s*:\s*(\d+(\.\d+)?)(?:\s*-\s*(\d+(\.\d+)?))?\s*\}?/i) ||
      checkMatch("volume", /\{?\s*Volume\s*:\s*(\d+(\.\d+)?)(?:\s*-\s*(\d+(\.\d+)?))?\s*\}?/i) ||
      checkMatch("height", /\{?\s*Height\s*:\s*(\d+(\.\d+)?)(?:\s*-\s*(\d+(\.\d+)?))?\s*\}?/i)
    );
  };
  const [searchInput, setSearchInput] = useState("");

  const visibleOptions = useMemo(() => {
    return filteredAndSortedOptions.filter(opt =>
      customFilterOption({ data: opt }, searchInput)
    );
  }, [filteredAndSortedOptions, searchInput]);
  return (
    <div
      ref={containerRef}
      style={{
        backgroundColor: '#1c1c1c',
        color: 'white',
        padding: '1em',
        borderRadius: '10px',
        border: '2px solid #0f5132',
        margin: '1em',
        minWidth: '300px',
        width: '95%',
        maxHeight: '90vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        position: "relative",
      }}
    >
      {/* Header + collapse-toggle */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h5 style={{ margin: 0 }}>Stem Curve</h5>

        {isPotree && (
          <button
            onClick={() => setCollapsed(c => !c)}
            aria-label={collapsed ? 'Expand panel' : 'Collapse panel'}
            style={{
              backgroundColor: 'transparent',
              border: '2px solid #a3de00',
              borderRadius: '4px',
              color: '#a3de00',
              fontSize: '1.5em',
              padding: '0.2em 0.4em',
              cursor: 'pointer',
              transition: 'background-color 0.2s, color 0.2s'
            }}
          >
            {collapsed ? '▼' : '▲'}
          </button>
        )}
      </div>
       {(!collapsed || !isPotree) && (
        <>
      {!isPotree && <DropdownMenu onRegenerate={handleGeneratePlots}/>}
      {!plotsMissing && 
      <button
          onClick={() => setShowFilters(prev => !prev)}
          style={{ alignSelf:'flex-start', background: 'none', border: 'none', cursor: 'pointer', color: '#a3de00', fontSize: '1.2em' }}
          aria-label="Toggle filter options"
        >
          <FaFilter style={{width: "1.5em",  height: "1.5em", color: "#a3de28"}}/>
        </button>
      }
      {/* Filters and Sorting */}
      {showFilters && (
        <div className="filter-dropdown">
          {["DBH", "volume", "height"].map(key => (
            <div key={key} className="filter-group">
              <label htmlFor={`range-${key}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                  {key.toUpperCase()}: {filters[key][0].toFixed(2)} – {filters[key][1].toFixed(2)}
              </label>
              <Range
                id={`range-${key}`}
                step={key === 'height' ? 1 : key === 'volume' ? 0.1 : 0.01}
                min={minMax[key][0]}
                max={minMax[key][1]}
                values={filters[key]}
                onChange={vals => updateFilter(key, vals)}
                renderTrack={({ props, children }) => (
                  <div {...props} style={{ ...props.style, height: '6px', background: getTrackBackground({
                    values: filters[key],
                    colors: ['#444', '#a3de00', '#444'],
                    min: minMax[key][0],
                    max: minMax[key][1]
                  }), borderRadius: '4px' }}>{children}</div>
                )}
                renderThumb={({ props, index }) => (
                  <div {...props} style={{ ...props.style, height: '16px', width: '16px', borderRadius: '50%', backgroundColor: '#a3de00', border: '2px solid #1c1c1c' }} >
                  </div>
                )}
              />
              <div className="range-labels" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                
                
              </div>
              <button onClick={() => toggleSort(key)}>
                Sort by {key.toUpperCase()} {sortBy === key ? (sortDirection === 'asc' ? '⬆️' : '⬇️') : ''}
              </button>
            </div>
          ))}
          <button onClick={() => toggleSort('ID')}>
            Sort by ID {sortBy === 'ID' ? (sortDirection === 'asc' ? '⬆️' : '⬇️') : ''}
          </button>
        </div>
      )}
      {/* Select Dropdown */}
       
      {!plotsMissing && 
      <div style={{ position: 'relative', display: 'inline-block', width: '95%' }}>
        
        <label htmlFor="tree-select" style={{ marginRight: '0.5em' }}>
          Search Tree, {visibleOptions.length} matching item{visibleOptions.length !== 1 ? 's' : ''}
        </label>
        <span
          style={{
            display: 'inline-block',
            cursor: 'pointer',
            borderBottom: '1px dotted white',
            color: '#a3de00',
            fontSize: '1.5em'
          }}
          title={`Search tips:
                  - 123 (ID)
                  - DBH: 0.45
                  - DBH: 0.3-0.5
                  - Volume: 1.0-2.5
                  - Height: 10-15`}
                    >
                      ?
        </span>
        
        <Select
          inputId="tree-select" 
          inputValue={searchInput} // 👈 CONTROLLED
          onInputChange={(inputValue, { action }) => {
            if (action !== 'set-value') {
              setSearchInput(inputValue);
            }
          }}
          blurInputOnSelect={false}
          closeMenuOnSelect={false}
          options={filteredAndSortedOptions}
          onChange={option => setSelectedId(option?.data || null)}
          filterOption={customFilterOption}
          placeholder="Select or search for an item..."
          value={filteredAndSortedOptions.find(opt => opt.data.ID === selectedId?.ID) || null}
          styles={{
            menu: base => ({ ...base, zIndex: 20 }),
            control: base => ({ ...base, backgroundColor: 'white', color: 'black' }),
            input: base => ({ ...base, color: 'black' }),
            option: (base, { isFocused }) => ({
              ...base,
              backgroundColor: isFocused ? '#eee' : 'white',
              color: 'black'
            })
          }}
        />
      </div>
      }
      {/* Selected Tree Info */}
      {selectedId && !plotsMissing && (
        <div style={{ marginTop: '1em', display: 'flex' }}>
          <p><strong>ID:</strong> {selectedId.ID} <strong> DBH:</strong> {selectedId.DBH}m <strong>  Height:</strong> {selectedId.height}m <strong>  Volume:</strong> {selectedId.volume}m³ <strong>  x, y:</strong> {selectedId.x}, {selectedId.y}</p>
        </div>
      )}
      {/* PNG Viewer with Navigation */}
      <div
        style={{
          position: 'relative',
          marginTop: '1em',
          border: '1px solid white',
          backgroundColor: '#222',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: 'auto', // allow it to grow
          minHeight: '300px' // optional: keeps some space reserved even before image loads
        }}
      >
        {/* Prev Button */}
        {!plotsMissing && 
        <button
          onClick={() => goTo(-1)}
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: '40px',
            backgroundColor: '#3330',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            zIndex: 10,
            transition: 'border 0.2s ease-in-out'
          }}
          onMouseEnter={e => (e.currentTarget.style.border = '2px solid white')}
          onMouseLeave={e => (e.currentTarget.style.border = 'none')}
        >
          ◀
        </button>
        } 

        {/* Next Button */}
        {!plotsMissing && 
        <button
          onClick={() => goTo(1)}
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: '40px',
            backgroundColor: '#3330',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            zIndex: 10,
            transition: 'border 0.2s ease-in-out'
          }}
          onMouseEnter={e => (e.currentTarget.style.border = '2px solid white')}
          onMouseLeave={e => (e.currentTarget.style.border = 'none')}
        >
          ▶
        </button>
        }
        {plotsMissing ? (
          
          <div style={{ textAlign: 'center', color: 'white', padding: '2em' }}>
            {startGeneration &&
              <button
                onClick={handleGeneratePlots}
                style={{
                  backgroundColor: '#a3de00',
                  border: 'none',
                  color: '#1c1c1c',
                  padding: '0.75em 1.5em',
                  fontSize: '1em',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  marginBottom: '1em'
                }}
              >
                Generate Stem Curve Plots
              </button>
            }
            {hasPlots === 'generating' &&  (
              <p style={{ marginTop: '1em' }}>
                Stem curve generation process has started. This may take a few minutes. You can refresh the page later to view the plots.
              </p>
            )}
          </div>
        ) : loading ? (
          <LoadingSpinner />
        ) : noSvg ? (
          <p style={{ color: 'white', textAlign: 'center' }}>No plot exists for this tree.</p>
        ) : (
          <img
            src={imageUrl}
            alt="Tree plot"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        )}
      </div>
      </>
       )}
    </div>
  );
};

export default StemCurveCard;